import { Grid } from '@mui/material';
import React, { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { getColors } from '../Shared/Functions';

export function PageTitle () {
    let location = useLocation();
    const [selectedPage, setSelectedPage] = useState<any>(null);
    let [tertiary, setTertiary] = useState<any>("#424449");

    useEffect(() => {
        getColors().then((x: any) => {
            setTertiary(x.tertiary)
        });
    }, [])

    useEffect(() => {
        switch(location.pathname){
            case '/account':
                setSelectedPage(null);
                break;
            case '/payment':
                setSelectedPage("MAKE PAYMENT");
                break;
            case '/history':
                setSelectedPage("ACCOUNT HISTORY");
                break;
            case '/wallet':
                setSelectedPage("PAYMENT METHODS");
                break;
            case '/manage':
                setSelectedPage("PROFILE SETTINGS");
                break;
            default:
                setSelectedPage("INSTAPAY");
                break;
        }
    }, [location])// eslint-disable-line react-hooks/exhaustive-deps

    return ( !selectedPage ? null :
        selectedPage === "INSTAPAY" ?
        <Grid sx={{ backgroundColor: tertiary, marginBottom: "10px"}}>
            <Grid container className='page-title page-title-light' style={{ color: "white" }}>
                <h2 style={{ fontSize: "27px", fontWeight: 300}}>
                    MAKE PAYMENT
                </h2>
            </Grid>
        </Grid>
        :
        <Grid sx={{ backgroundColor: "white", marginBottom: "10px"}}>
            <Grid container className='page-title'>
                <h2 style={{ fontSize: "27px", fontWeight: 300}}>
                    {selectedPage}
                </h2>
            </Grid>
        </Grid>
    );
}